import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'

import DatePickerRu from '../../../components/dataPicker'
import {
    ClearFilterButton,
    DateFilterCard,
    ModeBtn,
    ModeSwitch,
    ShowMoreButton,
    Sidebar,
    SidebarLabel,
} from '../../../components/scharedStyles/style'
import { buildRangePickerValue } from '../utils/formatScheduleDate'
import FilterSelect from '../../../components/FilterSelect'
import { AdvancedFilters, FiltersLayout } from './style'
import { useScheduleFilters } from './useScheduleFilters'

const ScheduleFilters = () => {
    const {
        dateFrom,
        dateTo,
        viewMode,
        selectedGroupId,
        selectedTeacherId,
        selectedBuildId,
        selectedRoomId,
        selectedClassTypeId,
        selectedSubjectId,
        showMoreOptions,
        isValidGroupValue,
        isValidTeacherValue,
        groupOptions,
        teacherOptions,
        buildingOptions,
        roomOptions,
        classTypeOptions,
        subjectOptions,
        setDateRange,
        clearDateFilter,
        changeViewMode,
        setSelectedGroupId,
        setSelectedTeacherId,
        selectBuild,
        setSelectedRoomId,
        setSelectedClassTypeId,
        setSelectedSubjectId,
        resetFilters,
        toggleShowMoreOptions,
    } = useScheduleFilters()

    const rangePickerValue = buildRangePickerValue(dateFrom, dateTo)

    return (
        <Sidebar $fixed>
            <FiltersLayout>
                <SidebarLabel>Основа расписания</SidebarLabel>
                <DateFilterCard>
                    Выберите даты
                    <DatePickerRu
                        style={{ width: '100%' }}
                        value={rangePickerValue}
                        format="DD.MM.YYYY"
                        placeholder={['С', 'По']}
                        onChange={(_, dateStrings) => setDateRange({
                            dateFrom: dateStrings?.[0] || '',
                            dateTo: dateStrings?.[1] || '',
                        })}
                    />
                    <ClearFilterButton type="button" onClick={clearDateFilter}>
                        Сбросить
                    </ClearFilterButton>
                </DateFilterCard>

                <ModeSwitch>
                    <ModeBtn
                        $active={viewMode === 'group'}
                        onClick={() => changeViewMode('group')}
                        type="button"
                    >
                        Группы
                    </ModeBtn>
                    <ModeBtn
                        $active={viewMode === 'teacher'}
                        onClick={() => changeViewMode('teacher')}
                        type="button"
                    >
                        Преподаватели
                    </ModeBtn>
                </ModeSwitch>

                {viewMode === 'group' ? (
                    <FilterSelect
                        label="Группы"
                        value={isValidGroupValue ? selectedGroupId : undefined}
                        onChange={setSelectedGroupId}
                        options={groupOptions}
                        placeholder="Выбрать группу"
                    />
                ) : (
                    <FilterSelect
                        label="Преподаватели"
                        value={isValidTeacherValue ? selectedTeacherId : undefined}
                        onChange={setSelectedTeacherId}
                        options={teacherOptions}
                        placeholder="Выбрать преподавателя"
                    />
                )}

                <AnimatePresence>
                    {showMoreOptions && (
                        <AdvancedFilters
                            as={motion.div}
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            <FilterSelect
                                label="Корпус"
                                value={selectedBuildId}
                                onChange={selectBuild}
                                options={buildingOptions}
                                placeholder="Выбрать корпус"
                            />

                            {selectedBuildId && (
                                <FilterSelect
                                    label="Кабинет"
                                    value={selectedRoomId}
                                    onChange={setSelectedRoomId}
                                    options={roomOptions}
                                    placeholder="Выбрать кабинет"
                                />
                            )}

                            <FilterSelect
                                label="Тип занятия"
                                value={selectedClassTypeId}
                                onChange={setSelectedClassTypeId}
                                options={classTypeOptions}
                                placeholder="Выбрать тип занятия"
                            />

                            <FilterSelect
                                label="Предмет"
                                value={selectedSubjectId}
                                onChange={setSelectedSubjectId}
                                options={subjectOptions}
                                placeholder="Выбрать предмет"
                            />

                            <ClearFilterButton type="button" onClick={resetFilters}>
                                Сбросить фильтры
                            </ClearFilterButton>
                        </AdvancedFilters>
                    )}
                </AnimatePresence>

                <ShowMoreButton type="button" onClick={toggleShowMoreOptions}>
                    {showMoreOptions ? 'Скрыть опции' : 'Показать больше опций'}
                </ShowMoreButton>
            </FiltersLayout>
        </Sidebar>
    )
}

export default ScheduleFilters
